// src/api/gazApi.ts — client de l'agrégation GAZ source-aware (ts-ingest, process indépendant de
// report-api). Remplace les anciens appels /api/dataenr/{siteId}/... pour le GAZ (report-api,
// server/routes/dataenr.ts, supprimé — cf. CLAUDE.md, section "Migration ÉLEC + GAZ vers
// ts-ingest"). Mirror exact de src/api/energyApi.ts (ÉLEC) : ts-ingest n'a aucune connaissance de
// reports.db, donc chaque fonction reçoit la liste de PCE du site déjà résolue + taggée par
// source ("grdf"|"engie") — cf. GazMetersCtx dans ReportA4.tsx, qui fait cette résolution une
// fois par site via metersApi.listPce().

import { APP_CONFIG } from "../config/app.config";

const BASE = APP_CONFIG.tsIngestBaseUrl;

export type GazSource = "grdf" | "engie";
export interface TaggedGazMeter { id: string; source: GazSource; }

async function tsRequest<T>(path: string): Promise<T> {
  const res = await fetch(`${BASE}${path}`);
  if (!res.ok) {
    const body = await res.text().catch(() => res.statusText);
    throw new Error(`ts-ingest ${res.status}: ${body}`);
  }
  return res.json() as Promise<T>;
}

function metersParam(meters: TaggedGazMeter[]): string {
  return meters.map(m => `${m.id}:${m.source}`).join(",");
}

export interface MonthlyGazResponse {
  consoGazTotaleParAn: Record<string, number>;
  consoGazTotaleParAnneeMois: Record<string, number>;
  consoGazTotaleParAnneeMoisReleve: Record<string, { dateDebut: string; dateFin: string }>;
  relevesGaz: Array<{ tsDebut: number; tsFin: number; energie: number; volBrut: number; volConv: number; qualif: string }>;
}
export function getMonthlyGaz(meters: TaggedGazMeter[], years: number[]): Promise<MonthlyGazResponse> {
  const qs = new URLSearchParams({ meters: metersParam(meters), years: years.join("_") });
  return tsRequest(`/conso/mensuelle/gaz?${qs}`);
}

export interface ConsoGazDetailResponse {
  perPce: Array<{ id: string; relevesGaz: Array<{ dateDebut: string; dateFin: string; energie: number; qualif: string }> }>;
}
export function getConsoGazDetail(meters: TaggedGazMeter[], years: number[]): Promise<ConsoGazDetailResponse> {
  const qs = new URLSearchParams({ meters: metersParam(meters), years: years.join("_") });
  return tsRequest(`/consogaz/detail?${qs}`);
}
